import React from 'react';

function LogoDark() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      fillRule='evenodd'
      strokeLinejoin='round'
      strokeMiterlimit='2'
      clipRule='evenodd'
      viewBox='0 0 1538 425'
    >
      <text
        x='0'
        y='0'
        fill='#9ACD32'
        fontFamily="'EpilepsySans', 'Epilepsy Sans'"
        fontSize='399.122'
        fontWeight='500'
        transform='matrix(.80134 0 0 .80176 633.059 298.654)'
      >
        ГИФКИ
      </text>
      <g transform='matrix(.88283 0 0 .94678 0 -572.198)'>
        <path
          fill='#9ACD32'
          fillRule='nonzero'
          d='M0 0v448h512V0H0zm32 32h448v376l-80-88-45.715 50.285L208 224 32 400V32zm96 288h96v96h-96v-96z'
          transform='translate(-3.475 604.362)'
        ></path>
        <path fill='#9ACD32' fillRule='nonzero' d='M288 668.362H384V764.362H288z'></path>
      </g>
    </svg>
  );
}

export default LogoDark;
